import { Box, IconButton, Badge } from "@mui/material";
import { useEffect, useState } from "react";
// import { ColorModeContext, tokens } from "../../theme";
// import InputBase from "@mui/material/InputBase";
// import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
// import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import LogoutIcon from '@mui/icons-material/Logout';
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
// import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
// import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
// import SearchIcon from "@mui/icons-material/Search";
import ElectionLogo from "./../../../assets/images/eci_logo.png"
// import { useOutlet } from "react-router-dom";
import Drawer from "@mui/material/Drawer";
import EvmLogo from "./../../../assets/images/evm_logo.png";
import "./Topbar.css";
import moment from 'moment'
import parse from 'html-react-parser';
import DOMPurify from 'dompurify';
import AnnouncementIcon from '@mui/icons-material/Announcement';
import TimeOut from './../../../common/TimeOut';
import environments from '../../../config';

const Topbar = ({isSidebar}) => {
  // const outlet = useOutlet();
  const [currentUserDetails] = useState(JSON.parse(window.sessionStorage.getItem('currentUserDetails')));

  // const theme = useTheme();
  // const colors = tokens(theme.palette.mode);
  // const colorMode = useContext(ColorModeContext);
  // const [userData, setUserData] = useState({username: null})
  // var Role = localStorage.getItem("Role");

  const [drawerAction, setDrawerAction] = useState('false')
  const handleNotification = () => {
    setDrawerAction('true');
  }

  const logout=()=> {
    if(window.confirm("Are you sure to Logoff from EMS?")) {
      logOut()
    }
  }

  function logOut() {
    fetch(`${process.env.REACT_APP_API}/user/UserLogout`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      }
    ).then((response) => {
      if (response.status === 200 || response.status === 401) {
        sessionStorage.removeItem("sessionToken", null);
        sessionStorage.removeItem('currentUserDetails', null);
        // setUserData(null)
        window.location.replace("/");
        localStorage.setItem("token", null);
      } else {
        sessionStorage.removeItem("sessionToken", null);
        sessionStorage.removeItem('currentUserDetails', null);
        // setUserData(null)
        window.location.replace("/");
        localStorage.setItem("token", null);
      }
    });
  }

/*  useEffect(() => {
    if (!sessionStorage.getItem('sessionToken')) {
      //console.log(outlet)
      // window.location.href = '/login'
    }

    // //console.log(outlet)
    // if(outlet.key){
    // 	window.location.href = '/page-not-found'
    // }

    // setUserData({
    //   userId: sessionStorage.getItem('sessionToken')
    // })
    return () => {}
  }, []) */

  // useEffect(() => { }, [drawerAction])

  const [alertDrawerAction, setAlertDrawerAction] = useState('false')
  const handleAlertNotification = () => {
    setAlertDrawerAction('true');
  }
  // useEffect(() => { }, [alertDrawerAction])

  var notNumber = 0;
  var alertNumber = 0;
  const [notNumbers, setNotNumbers] = useState(notNumber);
  const [alertNumbers, setAlertNumbers] = useState(alertNumber);
  const [notData, setNotData] = useState([]);
  const notIdArr = [];
  const alertIdArr = [];

  async function notificationCall() 
  {
    try {
      const response = await fetch(`${process.env.REACT_APP_API}/notification/notifications`, {
        method: "GET",
        credentials: "include",
        headers: { "Content-Type": "application/json" }
      })
      const data = await response.json();
      if(response.status === 200)
      {
        var value = data.data.length;
        if (value > 0) {
          let i;
          notNumber = 0;
          alertNumber = 0;
          for (i = 0; i < value; i++) {
            if ((data.data[i].action === "") && (data.data[i].type !== "OrderCrossed90Days")) {
              notNumber++;
              notIdArr.push(data.data[i].notificationId);
            }
            else {
              alertNumber++;
              alertIdArr.push(data.data[i].notificationId);
            }
  
          }
        }
        setNotNumbers(notNumber)
        setAlertNumbers(alertNumber)
        setNotData(data.data)
      }
    }
    catch (error) {
      throw new Error('Something went wrong');
    }
  }

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     notificationCall();
  //   }, 20000);

  //   return () => clearInterval(interval);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps    
  // }, [])

  function formatDate(string) {
    return moment(string).format('DD MMM, YYYY hh:mm A')
  }

  async function disMissNot(notid,num,tab) 
  {
    var newArray = []
    if(Number(num) === 0)
    {
      setNotData((prev) => 
      {
        return prev.filter((item) => { return item.notificationId !== notid })
      });
      newArray.push(notid);
      if(Number(tab) === 1)
      {
        setNotNumbers(Number(notNumber) - Number(1))
      }
      else if(Number(tab) === 2)
      {
        setAlertNumbers(Number(alertNumber) - Number(1))
      }
    }
    else
    {
      setNotData((prev) => 
      {
        return prev.filter((item) => { return item.notificationId !== notid })
      });
      // newArray.push(notid);
      if(Number(tab) === 1)
      {
        setNotNumbers(0)
      }
      else if(Number(tab) === 2)
      {
        setAlertNumbers(0)
      }
    }
    console.log(newArray)
    try {
      const response = await fetch(`${process.env.REACT_APP_API}/notification/dismissNotification`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          "notificationIdList": (Number(num) === 0) ? newArray : notid,
        })
      })
      const data = await response.json();
      if (data.status === 200) {
        notificationCall();
      }
    }
    catch (error) {
      throw new Error('Something went wrong');
    }
    if(num === 1 && tab === 1)
    {
      // setDrawerAction(false)
      setNotNumbers(0)
    }
    if(num === 1 && tab === 2)
    {

      // setAlertDrawerAction(false)
      setAlertNumbers(0)
    }

  }

  const htmlFrom = (htmlString) => {
      const cleanHtmlString = DOMPurify.sanitize(htmlString,
        { USE_PROFILES: { html: true } });
      const html = parse(cleanHtmlString);
      return html;
  }

  let ribbonText = "";  // Default value
  const currentUrl = window.location.href;

  for (const env in environments) {
    if (currentUrl.includes(environments[env].url)) {
      ribbonText = environments[env].ribbonText;
      break;
    }
  }

  return (
<>
    <Box display="flex" justifyContent="space-between" className="topBarFix" p={2}>
      {/* SEARCH BAR */}
      {/* <Box
        display="flex"
        backgroundColor={colors.primary[400]}
        borderRadius="3px"
      >
        <InputBase sx={{ ml: 2, flex: 1 }} placeholder="Search" />
        <IconButton type="button" sx={{ p: 1 }}>
          <SearchIcon />
        </IconButton>
      </Box> */}
      {/*  ECIl logo */}
      <Box display="flex">
        <img
          alt="profile-user"
          width="250px"
          height="50px"
          src={ElectionLogo}
          style={{ cursor: "default", borderRadius: "5%" , height: '50px', width: "auto" }}
        />
         {/* Ribbon */}
      </Box>
      {
        !isSidebar && ribbonText !== "" ?(
          <div className="ribbon">{ribbonText}</div>
        ): ""
      }
      <Box sx={{width : "100px", height: '50px', marginTop: '-30px'}}>
      <img
          alt="profile-user"
          src={EvmLogo}
          style={{ cursor: "pointer", borderRadius: "5%" }}
        />
      </Box>
      {/* ICONS */}
     
      <Box display="flex">
      <div style={{display:'flex',padding:'15px 50px 0 0'}}>
      <strong style={{paddingRight:'15px', color: '#194778'}}>{currentUserDetails.name}</strong> |
      <strong style={{paddingRight:'15px',paddingLeft:'15px', color: '#D26969'}}> {currentUserDetails.role}</strong> |
      <strong style={{paddingLeft:'10px', color: 'purple'}}> {currentUserDetails.stateId}</strong> 
      <strong style={{paddingLeft:'10px', color: 'purple'}}> {currentUserDetails.districtId}</strong>
      </div>
        <IconButton onClick={notNumbers >= 0 ? handleNotification : ""}>
          {
            notNumbers > 0 ?
            <Badge badgeContent={notNumbers} color="secondary">
              <AnnouncementIcon />
            </Badge>
            :
            <AnnouncementIcon />
          }

          {/* <Badge badgeContent={notNumbers} color="secondary">
            <AnnouncementIcon />
          </Badge> */}

        </IconButton>

        <IconButton onClick={alertNumbers >= 0 ? handleAlertNotification : ""}>

          {
            alertNumbers > 0 ?
            <Badge badgeContent={alertNumbers} sx={{
              "& .MuiBadge-badge": {
                color: "white",
                backgroundColor: "red"
              }
            }} >
              <NotificationsOutlinedIcon sx={{ color: "red" }} />
            </Badge>
            :
            <NotificationsOutlinedIcon sx={{ color: "red" }} />
          }
          {/* <Badge badgeContent={alertNumbers} sx={{
            "& .MuiBadge-badge": {
              color: "white",
              backgroundColor: "red"
            }
          }} >
            <NotificationsOutlinedIcon sx={{ color: "red" }} />
          </Badge> */}

        </IconButton>

        <Drawer anchor="right" open={drawerAction === "false" ? "" : "true"} onBackdropClick={() => { setDrawerAction('false'); } }>
          <Box sx={{ width: 450 }} role="presentation">
            <div className="d-block mx-3 my-3 msgbox">
              <h6 className="msgheader">
                Notifications
                <p className="m-0 cursor-pointer align-items-center d-flex" onClick={() => disMissNot(notIdArr,"1","1")}>Dismiss All &nbsp;<span className="font-32"> &times; </span></p>
              </h6>
              <hr className="msgheaderline"/>
              <div className="boxes">
                {
                  notNumbers !== 0 ?
                    // eslint-disable-next-line array-callback-return
                    notData.map((val, index) => {                       
                      if ((val.action === "") || (val.action === undefined) || (val.action === null) || (val.type !== "OrderCrossed90Days")) {
                        notIdArr.push(val.notificationId);
                        return (
                          <div className="notblock" id={val.notificationId} key={index}>
                            <span>
                              {htmlFrom(val.message)}
                              <p>{formatDate(val.creationTime)}</p>
                            </span>
                            <span className="closeicon" onClick={() => {disMissNot(val.notificationId,"0","1")}}>&times;</span>
                          </div>
                        )
                      }
                    })
                  :
                  <center className="align-items-center py-3">No New Notifications found</center>
                }
              </div>
            </div>
          </Box>
        </Drawer>

        <Drawer anchor="right" open={alertDrawerAction === "false" ? "" : "true"} onBackdropClick={() => { setAlertDrawerAction('false'); } }>
          <Box sx={{ width: 450 }} role="presentation">
            {/* <div className="d-flex py-3 align-items-center justify-content-end">
              <h1 className="m-0 px-4 cursor-pointer" onClick={(e) => { setAlertDrawerAction('false'); }} >&times;</h1>
            </div> */}
            <div className="d-block mx-3 my-3 alertbox">
              <h6 className="alertheader">
                Alerts
                <p className="m-0 cursor-pointer align-items-center d-flex" onClick={() => disMissNot(alertIdArr,"1","2")}>Dismiss All &nbsp;<span className="font-32"> &times; </span></p>
              </h6>
              <hr className="alertheaderline"/>
              <div className="boxes">
                {
                  alertNumbers !== 0 ?
                    // eslint-disable-next-line array-callback-return
                    notData.map((val, index) => {
                      if ((val.action !== '') || (val.type === "OrderCrossed90Days")) {
                        alertIdArr.push(val.notificationId);
                        return (
                          <div className="alertnotblock" id={val.notificationId} key={index}>
                            <span>
                              {htmlFrom(val.message)}
                              <p>{formatDate(val.creationTime)}</p>
                            </span>
                            <span className="closeicon" onClick={() => {disMissNot(val.notificationId,"0","2")}}>&times;</span>
                          </div>
                        )
                      }
                    })
                  :
                  <center className="align-items-center py-3">No New Alerts were found</center>
                }
              </div>
            </div>
          </Box>
        </Drawer>

        {/* <IconButton>
          <SettingsOutlinedIcon />
        </IconButton>
        <IconButton>
          <PersonOutlinedIcon />
        </IconButton> */}
        <IconButton onClick={logout}>
          <LogoutIcon />
        </IconButton>
        {/* <IconButton onClick={colorMode.toggleColorMode}>
          {theme.palette.mode === "dark" ? (
            <DarkModeOutlinedIcon />
          ) : (
            <LightModeOutlinedIcon />
          )}
        </IconButton> */}

      </Box>
    </Box>
    <TimeOut />
    </>
  );
};

export default Topbar;